import {SystemPopupView} from '@gongxigames/framework/slotCommon/modules/systemPopupsManager/popups/SystemPopupView';
import {FlexBoxComponent, RichText} from '@gongxigames/framework/core/fragments/react';
import {AutoplayToggleInput} from '@gongxigames/framework/slot/modules/autoplayOptions/popup/components/AutoplayToggleInput';
import {HorizontalSeparator} from '@gongxigames/framework/slot/modules/autoplayOptions/popup/components/HorizontalSeparator';
import {AutoplayRoundsSelector} from '@gongxigames/framework/slot/modules/autoplayOptions/popup/components/AutoplayRoundsSelector';
import {StartButton} from '@gongxigames/framework/slot/modules/autoplayOptions/popup/components/StartButton';
import React from 'react';
import {ToggleTurboModeButton} from '@gongxigames/framework/slot/modules/autoplayOptions/popup/components/ToggleTurboModeButton';
import {AutoplayOptionsOptionsKeys} from '@gongxigames/framework/slot/types';

export type AutoplayOptionsPopupComponentProps = {
    onClickClose?: () => void;
    onClickStart?: () => void;
    onChangeLossLimit?: (value: number | null) => void;
    onChangeWinLimit?: (value: number | null) => void;
    onChangeSingleWin?: (value: number | null) => void;
    onToggleTurboMode?: (value: boolean | null) => void;
    onChangeRounds?: (value: number | null) => void;
    singleWin?: null | number;
    winLimit?: null | number;
    lossLimit?: null | number;
    roundsOptions?: number[];
    autoplaySpins?: null | number;
    turboMode?: null | boolean;
    turboModeDisabled?: boolean;
    disabledLimits?: boolean;
    notValidValues?: AutoplayOptionsOptionsKeys[];
    autoplayShowBetAndWager?: boolean;
    betFormatedValue?: string;
    wagerFormatedValue?: string;
};

export class AutoplayOptionsPopupComponent extends React.Component<AutoplayOptionsPopupComponentProps> {
    render(): JSX.Element {
        const {
            onChangeLossLimit = () => {},
            onChangeWinLimit = () => {},
            onChangeRounds = () => {},
            onChangeSingleWin = () => {},
            onToggleTurboMode = () => {},
            onClickClose = () => {},
            onClickStart = () => {},
            notValidValues = [],
            singleWin = null,
            winLimit = null,
            lossLimit = null,
            roundsOptions = [],
            turboModeDisabled = false,
            disabledLimits = false,
            autoplaySpins = null,
            turboMode = null,
            autoplayShowBetAndWager = false,
            betFormatedValue = '',
            wagerFormatedValue = ''
        } = this.props;

        const width = 1510;
        const gapBetweenElements = 50;
        const padding = {top: 80, left: 80, bottom: 80, right: 80};
        const horizontalPaddingSum = padding.left + padding.right;
        const widthWithoutPadding = width - horizontalPaddingSum;

        return (
            <SystemPopupView
                title={'autoplayOptions'}
                closeButtonEnabled={true}
                onClickClose={onClickClose}
                gapBetweenElements={gapBetweenElements}
                width={width}
            >
                <FlexBoxComponent
                    name={'SystemPopupView-content'}
                    direction={'column'}
                    debug={false}
                    padding={padding}
                    gap={gapBetweenElements}
                    justifyContent={'center'}
                    alignItems={'start'}
                >
                    <AutoplayToggleInput
                        name='singleWin'
                        width={widthWithoutPadding}
                        isNotValid={notValidValues?.includes('singleWin')}
                        titleID={'singleWin'}
                        value={singleWin}
                        onChange={onChangeSingleWin}
                        hidden={disabledLimits}
                    />
                    <AutoplayToggleInput
                        name='winLimit'
                        width={widthWithoutPadding}
                        isNotValid={notValidValues?.includes('winLimit')}
                        titleID={'winLimit'}
                        value={winLimit}
                        onChange={onChangeWinLimit}
                        hidden={disabledLimits}
                    />
                    <AutoplayToggleInput
                        name='lossLimit'
                        width={widthWithoutPadding}
                        isNotValid={notValidValues?.includes('lossLimit')}
                        titleID={'lossLimit'}
                        value={lossLimit}
                        onChange={onChangeLossLimit}
                        hidden={disabledLimits}
                    />
                    <HorizontalSeparator width={widthWithoutPadding} hidden={disabledLimits} />
                    <AutoplayRoundsSelector
                        gapBetweenOptions={gapBetweenElements}
                        width={widthWithoutPadding}
                        isNotValid={notValidValues?.includes('autoplaySpins')}
                        onChange={onChangeRounds}
                        options={roundsOptions}
                        value={autoplaySpins}
                        itemSize={{width: 290, height: 180}}
                    />
                    <HorizontalSeparator width={widthWithoutPadding} />
                    <ToggleTurboModeButton
                        hidden={turboModeDisabled}
                        value={turboMode}
                        width={widthWithoutPadding}
                        onToggle={onToggleTurboMode}
                    />
                    <FlexBoxComponent
                        name={'AutoplayPopupTextAndStart'}
                        containerWidth={widthWithoutPadding}
                        alignItems={'center'}
                        direction={'column'}
                        gap={gapBetweenElements}
                    >
                        <RichText id={'autoplayStopBonus'} style={'AutoplayPopupText'} maxWidth={widthWithoutPadding} resolution={1}/>
                        {autoplayShowBetAndWager && <FlexBoxComponent
                            name={'AutoplayPopupTextAndStart'}
                            containerWidth={widthWithoutPadding}
                            alignItems={'start'}
                            direction={'row'}
                            gap={gapBetweenElements}
                        >
                            <RichText id={'autoplayBet'} values={{bet: betFormatedValue}} style={'AutoplayPopupBetText'}
                                      maxWidth={widthWithoutPadding} resolution={1}/>
                            <RichText id={'autoplayTotalWager'} values={{wager: wagerFormatedValue}}
                                      style={'AutoplayPopupBetText'} maxWidth={widthWithoutPadding} resolution={1}/>
                        </FlexBoxComponent>}
                        <StartButton onClick={onClickStart}/>
                    </FlexBoxComponent>
                </FlexBoxComponent>
            </SystemPopupView>
        );
    }
}
